import { Component } from '../Component'
import { inject } from '../../services/di'
import { element } from '../CustomElement'
import { i18n } from '../../i18n/I18n'
import { LocationService } from '../../services/LocationService'
import { CategoryService } from '../../services/CategoryService'
import { icons } from '../../icons/Icons'
import { BannerService } from '../../services/BannerService'
import cx from 'classnames'
import { BlackFridayService } from '../../services/BlackFridayService'

@element('topbar-giveaway-banner')
export class TopbarGiveawayBanner extends Component<any, any> {
    @inject location: LocationService
    @inject categoryService: CategoryService
    @inject bannerService: BannerService
    @inject blackFridayService: BlackFridayService

    render() {
        const topBarBanner = this.bannerService.getTopBarBanner()
        if (!topBarBanner) return null

        const title = i18n('giveaway_title')
        const subtitle = i18n('giveaway_banner_date')
        const buttonText = i18n('giveaway_banner_button_text')

        return (
            <div
                class={cx('giveaway', {
                    bf: this.blackFridayService.isOnHost(),
                })}
            >
                {icons.deals}
                <div class="giveaway__text">
                    <div class="giveaway__title">{title}</div>
                    <div class="giveaway__date">{subtitle}</div>
                </div>
                <a
                    href={this.bannerService.getGiveawayLink()}
                    target="_blank"
                    class="giveaway__button"
                    id="giveaway-banner-top__button"
                >
                    {buttonText}
                    {icons.rightArrow}
                </a>
            </div>
        )
    }
}
